<style src="./ReportComputedCredit.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="filterReport">
        <div class="row">
          <div class="col-lg-8">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="col-sm-12">Data</label>
                <div class="col-sm-12">
                  <input
                    type="date"
                    placeholder="30/12/2019"
                    class="form-control"
                    v-model="startDate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
          <div class="col-sm-2">
            <button
              class="btn btn-lg btn-primary"
              type="button"
              @click="exportCsv"
            >
              <i class="fa fa-download"></i>
              Exportar CSV
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="ibox-content">
      <div class="alert alert-success" v-show="totalAmountPaid">
        <div class="row">
          <div class="col-6">
            Quantidade de Registros:
            <strong>{{ countPages }}</strong>
          </div>
          <div class="col-6">
            Valor Total:
            <strong>R$ {{ totalToCurrencyBR(totalAmountPaid) }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <tr>
            <th>Código</th>
            <th>Estacionamento</th>
            <th>Data</th>
            <th>Hora</th>
            <th>Valor</th>
            <th>Minutos</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in resultList" :key="idx">
            <td>{{ item.uniqueCode }}</td>
            <td>{{ item.parkName }}</td>
            <td>{{ fillDate(item.startDate) }}</td>
            <td>{{ fillTime(item.startDate) }}</td>
            <td>{{ totalToCurrencyBR(item.settledAmountPaid) }}</td>
            <td>{{ item.totalMinutes }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-group paginatecontent" v-if="countPages > 0">
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>

      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';
import { toast } from '@/plugins/toast';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        pageSkip: 0,
        pageLimit: 10,
        showSettled: true,
      },
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      totalAmountPaid: null,
      countPages: 0,
      employeeList: [],
      rawList: [],
    };
  },
  computed: {
    resultList() {
      return this.rawList.slice(
        this.form.pageSkip,
        this.form.pageLimit + this.form.pageSkip,
      );
    },
    hasPageLeft() {
      return this.form.pageSkip === 0;
    },
    hasPageRight() {
      return this.form.pageSkip + this.form.pageLimit >= this.countPages;
    },
  },
  mounted() {
    const dt = new Date();
    this.startDate = `${dt.getFullYear()}-${('0' + (dt.getMonth() + 1)).slice(
      -2,
    )}-${('0' + dt.getDate()).slice(-2)}`;
    this.endDate = `${dt.getFullYear()}-${('0' + (dt.getMonth() + 1)).slice(
      -2,
    )}-${('0' + dt.getDate()).slice(-2)}`;
    this.endTime = '23:59:00';
    this.startTime = '01:00:00';
  },
  methods: {
    fillDate(value) {
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      return new Date(value).toLocaleTimeString('pt-BR');
    },
    totalToCurrencyBR(value) {
      if (!value) {
        return '-';
      }
      return (value / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
      });
    },
    generateQuery() {
      const query = {
        ...this.form,
      };

      query.startDate = new Date(`${this.startDate} 01:00:00`);
      query.endDate = new Date(`${this.startDate} 23:59:59`);
      return query;
    },
    async filterReport() {
      this.showSpinner = true;
      this.totalAmountPaid = null;

      const query = this.generateQuery();

      try {
        const reports = await this.$store.dispatch(
          'REPORTS/ReportComputedCredit',
          {
            query,
          },
        );

        if (!reports.list) {
          this.rawList = [];
          return true;
        }

        this.pageSkip = 0;
        this.countPages = reports.count;

        const resultList = reports.list.map(item => {
          const uniqueCode = item.uniqueCode;
          const amountPaid = item.amountPaid;
          const settledAmountPaid = item.settledAmountPaid;
          const totalMinutes = item.totalMinutes;
          const parkName = item.parks ? item.parks.parkName : '-';
          const startDate = item.paymentDate;

          return {
            uniqueCode,
            amountPaid,
            totalMinutes,
            parkName,
            startDate,
            settledAmountPaid,
          };
        });

        this.totalAmountPaid = reports.totalPaid;
        this.rawList = resultList;
        this.showSpinner = false;
      } catch (error) {
        this.rawList = [];
        this.showSpinner = false;
      }
    },
    async exportCsv() {
      this.showSpinner = true;
      this.totalAmountPaid = null;

      const query = this.generateQuery();

      try {
        const response = await this.$store.dispatch(
          'REPORTS/DownloadComputedCreditCsv',
          {
            query,
          },
        );
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'RELATORIO DE CREDITOS.csv');
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        toast.error('Não foi possível exportar');
      } finally {
        this.showSpinner = false;
      }
    },
    nextPage() {
      if (this.form.pageSkip + this.form.pageLimit > this.countPages) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip + this.form.pageLimit;
    },
    previousPage() {
      if (this.form.pageSkip === 0) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip - this.form.pageLimit;
    },
  },
};
</script>
